// 抑制 Element Plus 常见的良性 ResizeObserver 循环报错
const resizeObserverLoopErrRe = /^ResizeObserver loop/
window.addEventListener('error', (e) => {
    if (e.message && resizeObserverLoopErrRe.test(e.message)) {
        e.stopImmediatePropagation()
        e.preventDefault()
        return false
    }
})
import { createHead } from '@vueuse/head'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'  // 确保引入路由
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 必须在 element-plus 之后，深色主题变量才能覆盖其默认亮色
import '@/assets/styles/theme.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { registerVideoCache } from './js/videoCache'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(createPinia())
app.use(router)  // 使用路由
app.use(ElementPlus)
// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
// app.use('/api', createProxyMiddleware({ 
//     target: 'http://dca.newmousesmart.com', 
//     changeOrigin: true 
//   }));
app.mount('#app')
registerVideoCache()
//app.listen(3000);
